<template>
  <div id="contenedor-exportar-conceptos-contratos">
    <v-card v-if="$apollo.loading">
      <v-container>
        <v-row
          class="fill-height"
          align-content="center"
          justify="center">
          <v-col
            class="text-subtitle-1 text-center"
            cols="12">
            Preparando exportación de conceptos de contratos...
          </v-col>
          <v-col cols="6">
            <v-progress-linear
              color="primary"
              indeterminate
              rounded
              height="6">
            </v-progress-linear>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
    <v-form
      v-else
      ref="exportarConceptosContratos"
      v-model="formularioValido">
      <v-card>
        <v-card-title class="secondary--text">
          Exportar Conceptos de Contratos
          <v-spacer></v-spacer>
          <v-btn icon @click="cerrar">
            <v-icon class="secondary--text" large>highlight_off</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-row justify="center">
            <strong class="secondary--text" style="font-size:16px">
              Seleccionar Rango de Fechas
            </strong>
            <custom-date-picker
              v-model="rangoFechas.inicial"
              :rules="[mixReglas.requerido]"
              label="Fecha Inicial">
            </custom-date-picker>
            <custom-date-picker
              v-model="rangoFechas.final"
              :rules="[mixReglas.requerido]"
              label="Fecha Final">
            </custom-date-picker>
          </v-row>
          <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button
            @click="cerrar"
            tipo="formCancelar"
            label="Cancelar"
            class="mr-3">
          </custom-button>
          <custom-button
            label="Exportar"
            tipo="formAceptar"
            :disabled="!formularioValido"
            :loading="estaCargando"
            @click="generarExcelConceptosContratos">
          </custom-button>
        </v-card-actions>
        </v-card-text>
      </v-card>
    </v-form>
  </div>
</template>

<script>
import CONTRATOS_EXCEL_CONCEPTOS from '@/graphql/querys/administracion/contratos/contratosExcelConceptos.gql';
import mixGenerarExcel from '@/helpers/mixGenerarExcel';
import CustomDatePicker from '@/components/inputs/DatePicker.vue';
import CustomButton from '@/components/buttons/Button.vue';

// Fila en la que inician los datos con titulos del excel
const filaTitulos = 4;
// const filaSubtitulos = filaTitulos + 1;
const filaInicioDatos = filaTitulos + 1;

export default {
  name: 'ExcelConceptosContratos',
  mixins: [mixGenerarExcel],
  components: {
    CustomDatePicker,
    CustomButton,
  },
  apollo: {
    contratos: {
      query: CONTRATOS_EXCEL_CONCEPTOS,
    },
  },
  data() {
    return {
      formularioValido: false,
      estaCargando: false,
      rangoFechas: {
        inicial: null,
        final: null,
      },
      nombreDocumento: 'CONCEPTOS DE CONTRATOS',
      configuracionExcel: {},
      // Estilo del header
      estiloHeader: {
        font: {
          bold: true,
        },
        alignment: {
          horizontal: 'center',
          vertical: 'center',
          wrapText: true,
        },
      },
      headersColumnas: [
        {
          value: 'FECHA DE CONTRATO', nombreColumna: 'fechaContrato', orden: 0,
        },
        {
          value: 'NUMERO CONTRATO', nombreColumna: 'numeroContrato', orden: 1,
        },
        {
          value: 'OBJETO', nombreColumna: 'objeto', orden: 2,
        },
        {
          value: 'CONTRATISTA', nombreColumna: 'contratista', orden: 3,
        },
        {
          value: 'PARTIDA', nombreColumna: 'partida', orden: 4,
        },
        {
          value: 'SUBPARTIDA', nombreColumna: 'subPartida', orden: 5,
        },
        {
          value: 'CLAVE', nombreColumna: 'claveConcepto', orden: 6,
        },
        {
          value: 'DESCRIPCIÓN', nombreColumna: 'descripcion', orden: 7,
        },
        {
          value: 'UNIDAD', nombreColumna: 'unidad', orden: 8,
        },
        {
          value: 'PRECIO', nombreColumna: 'precio', orden: 9,
        },
        {
          value: 'IMPORTE', nombreColumna: 'importe', orden: 10,
        },
        {
          value: 'FAVORITO', nombreColumna: 'esFavorito', orden: 11,
        },
      ],
      noData: [{
        fechaContrato: '',
        numeroContrato: '',
        objeto: '',
        contratista: '',
        partida: '',
        subPartida: '',
        claveConcepto: '',
        descripcion: '',
        unidad: '',
        precio: '',
        importe: '',
        esFavorito: '',
      }],
      estilos: {
        centrado: {
          alignment: {
            horizontal: 'center',
            vertical: 'center',
          },
        },
        dinero: {
          numberFormat: '$#,##0.00',
        },
      },
    };
  },
  methods: {
    async generarExcelConceptosContratos() {
      this.estaCargando = true;
      const data = this.crearExcelObras;
      await this.mixGenerarExcel(data);
    },
    cerrar() {
      this.$refs.exportarConceptosContratos.reset();
      this.rangoFechas.inicial = null;
      this.rangoFechas.final = null;
      this.$emit('cerrar');
    },
    // metodo para obtener el padre de cualquier concepto recibido
    getPadreConcepto(conceptoBuscar) {
      const padreConcepto = this.getConceptosTodos
        .find((concepto) => concepto.id === conceptoBuscar.id);
      if (!padreConcepto.padre) {
        return {
          id: '',
          tipo: 0,
          clave: '',
          concepto: '',
        };
      }
      return padreConcepto.padre;
    },
    getPartidaConcepto(concepto) {
      let contador = 0;
      // Obtengo el padre del conceptop recibido
      let esteConcepto = this.getPadreConcepto(concepto);
      // ciclo para buscar la partida principal del concepto.
      // el ciclo esta limitado a 10 intentos y se rompe al encontrar la partida del concepto.
      while (contador < 10) {
        // si el padre es tipo 0 el ciclo se rompe y se retornan los datos de la partida
        if (esteConcepto.tipo === 0) {
          return {
            clave: esteConcepto.clave,
            concepto: esteConcepto.concepto,
          };
        }
        // Obtengo el padre del conceptop actual
        esteConcepto = this.getPadreConcepto(esteConcepto);
        contador += 1;
      }
      return {
        clave: '',
        concepto: '',
      };
    },
  },
  computed: {
    getContratos() {
      if (!this.contratos) return [];
      return this.contratos
        .slice()
        .sort((a, b) => new Date(b.fecha) - new Date(a.fecha));
    },
    getConceptosTodos() {
      if (!this.getContratos) return [];
      const conceptosTodos = [];
      this.getContratos.forEach((contrato) => {
        if (contrato.catalogoConceptos.length > 0) {
          const isBetween = this.$moment(contrato.fecha)
            .isBetween(this.rangoFechas.inicial, this.rangoFechas.final, undefined, '[]');
          if (isBetween) {
            contrato.catalogoConceptos.forEach((concepto) => {
              conceptosTodos.push(concepto);
            });
          }
        }
      });
      return conceptosTodos;
    },
    getConceptosContratos() {
      if (!this.getContratos) return [];
      const conceptosContratos = [];
      this.getContratos.forEach((contrato) => {
        if (contrato.catalogoConceptos.length > 0) {
          // Verificar que la fecha de contrato se encuentre dentro del rango de fechas
          const isBetween = this.$moment(contrato.fecha)
            .isBetween(this.rangoFechas.inicial, this.rangoFechas.final, undefined, '[]');
          if (isBetween) {
            contrato.catalogoConceptos
              .sort((a, b) => a.orden - b.orden)
              .forEach((concepto) => {
                if (concepto.tipo === 2) {
                  const partidaConcepto = this.getPartidaConcepto(concepto);
                  conceptosContratos.push({
                    fechaContrato: {
                      value: this.$moment(contrato.fecha).format('DD/MM/YYYY'),
                      estilo: {
                        ...this.estilos.centrado,
                      },
                    },
                    numeroContrato: contrato.numero,
                    objeto: contrato.meta,
                    contratista: contrato.contratista.nombreRazonSocial,
                    partida: `${partidaConcepto.clave} - ${partidaConcepto.concepto}`,
                    subPartida: concepto.padre?.tipo === 1 ? `${concepto.padre.clave} - ${concepto.padre.concepto}` : '-',
                    claveConcepto: {
                      value: concepto.clave,
                      estilo: {
                        ...this.estilos.centrado,
                      },
                    },
                    descripcion: concepto.concepto,
                    unidad: {
                      value: concepto.unidad,
                      estilo: {
                        ...this.estilos.centrado,
                      },
                    },
                    precio: {
                      value: concepto.precioUnitario,
                      estilo: {
                        ...this.estilos.dinero,
                      },
                    },
                    importe: {
                      value: concepto.importe,
                      estilo: {
                        ...this.estilos.dinero,
                      },
                    },
                    esFavorito: {
                      value: concepto.esFavorito ? 'Si' : 'No',
                      estilo: {
                        ...this.estilos.centrado,
                      },
                    },
                  });
                }
              });
          }
        }
      });
      return conceptosContratos;
    },
    crearDatosDocumento() {
      const inicial = this.$moment(this.rangoFechas.inicial).format('DD/MM/YYYY');
      const final = this.$moment(this.rangoFechas.final).format('DD/MM/YYYY');
      const datosDocumento = [];
      datosDocumento.push(
        {
          value: `CONCEPTOS DE CONTRATOS DEL ${inicial} AL ${final}`,
          row: 2,
          col: 1,
          estilo: {
            font: {
              size: 16,
              bold: true,
            },
            alignment: {
              horizontal: 'left',
              vertical: 'center',
            },
          },
          combinar: {
            row: 2,
            col: 27,
          },
        },
      );
      return datosDocumento;
    },
    getHeaders() {
      const headers = this.headersColumnas
        .map((header) => header.value)
        .sort((a, b) => a.orden - b.orden);
      return headers;
    },
    getColumnas() {
      const columnas = this.headersColumnas
        .map((columna) => columna.nombreColumna)
        .sort((a, b) => a.orden - b.orden);
      return columnas;
    },
    crearExcelObras() {
      const datosDocumento = this.crearDatosDocumento;
      const dataHeaders = this.getHeaders;
      const nombreDeColumnas = [...this.getColumnas];
      const bodyData = this.getConceptosContratos.length > 0
        ? this.getConceptosContratos : this.noData;
      const data = {
        excelData: {
          configuration: this.configuracionExcel,
          header: {
            filaInicio: filaTitulos,
            estilo: this.estiloHeader,
            datosDocumento: [...datosDocumento],
            data: [...dataHeaders],
          },
          body: {
            nombreDeColumnas,
            filaInicio: filaInicioDatos,
            data: bodyData,
          },
        },
      };
      return data;
    },
  },
};
</script>

<style>

</style>
